import { jsx as _jsx } from "react/jsx-runtime";
import { memoGeneric } from '@/js/libs/memo';
import { TabsGroupWrapper } from './styled';
import { TabsGroupContent } from './TabsGroupContent';
export const TabsGroup = memoGeneric(function TabsGroup(props) {
    return (_jsx(TabsGroupWrapper, { children: _jsx(TabsGroupContent, { ...props }) }));
});
